module.exports = __webpack_public_path__ + "static/media/ReadInsightIcon.d611a565.svg";